import * as React from 'react';
import { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { color } from '@core-ds/primitives';
import { relativeDate as getRelativeDate, MINUTE } from '../../../realtime_date';

const Icon = styled.i`
   width: 25px;
   margin-bottom: auto;

   text-align: center;
   line-height: 1.55em;

   opacity: 0.3;
   transition: color 0.2s, opacity 0.2s;
`;

const NotificationInfo = styled.div`
   display: flex;
   flex-flow: column nowrap;

   margin-left: 10px;
   flex: 1;

   text-align: left;
   overflow: hidden;
   overflow-wrap: break-word;

   time {
      opacity: 0.4;
   }

   :hover,
   :active {
      outline: none;
   }
`;

const NotificationLink = styled.a`
   display: flex;
   flex-flow: row nowrap;

   padding: 10px;

   color: ${color.gray8};
   :visited {
      color: ${color.gray8};
   }

   :hover {
      background-color: ${color.gray1};
      text-decoration: none;

      ${Icon} {
         opacity: 1;
         color: ${color.blueLight1};

         :last-child {
            :hover {
               color: ${color.blueDark2};
            }
         }
      }
   }
`;

const getIconClass = icon => `fa fa-${icon}`;

const NotificationCard = ({ metadata, markRead }) => {
   const date = new Date(metadata.date);

   const [relativeDate, setRelativeDate] = useState(getRelativeDate(date));

   useEffect(() => {
      function updateRelativeDate() {
         setRelativeDate(getRelativeDate(date));
      }

      const timerID = setInterval(() => updateRelativeDate(), MINUTE);
      return function cleanup() {
         clearInterval(timerID);
      };
   }, []);

   const onClickGenerator = useCallback(
      redirect => e => {
         markRead();
         if (redirect) {
            window.location.href = metadata.url;
         }
         e.stopPropagation();
      },
      [markRead, metadata.url]
   );

   const onKeyDownGenerator = useCallback(
      redirect => e => {
         e.key === 'Enter' && onClickGenerator(redirect)(e);
      },
      [onClickGenerator]
   );

   return (
      <li>
         <NotificationLink onClick={onClickGenerator(true)} onKeyDown={onKeyDownGenerator(true)}>
            <Icon className={getIconClass(metadata.icon)} />
            <NotificationInfo tabIndex="0">
               <div>{_js(metadata.message)}</div>
               <time title={metadata.date} dateTime={date.toISOString()}>
                  {relativeDate}
               </time>
            </NotificationInfo>
            <Icon
               tabIndex="0"
               className={getIconClass('times')}
               onClick={onClickGenerator(false)}
               onKeyDown={onKeyDownGenerator(false)}
            />
         </NotificationLink>
      </li>
   );
};

export default NotificationCard;
